import CandidatePortraits from 'lib/CandidatePortraits/CandidatePortraits';
import MunicipalityList from 'lib/MunicipalityList/MunicipalityList';
import React from 'react';
import { CountingCirclesResponse } from 'api/api.types';
import { FormattedList, getFormattedCandidates } from '../utils/getFormattedCandidates';
import { useGetFormattedLists } from '../utils/useGetFormattedLists';

interface Props {
  aggregatingDomainsData: CountingCirclesResponse;
  formattedParties: FormattedList[];
}

const BiProportionalElectedMunis = ({
  aggregatingDomainsData,
  formattedParties,
}: Props) => {
  return (
    <MunicipalityList
      showNumberOfSeats
      hideSearchbar
      municipalities={aggregatingDomainsData?.data.records}
      checksum={aggregatingDomainsData?.meta.data_checksum_sha256}
      render={(municipality) => {
        const lists = useGetFormattedLists(municipality?.lists);
        const candidatesMuni = getFormattedCandidates(
          municipality?.candidates,
          lists,
          formattedParties,
        ).filter((candidate) => candidate.elected);
        return <CandidatePortraits candidates={candidatesMuni} />;
      }}
    />
  );
};

export default BiProportionalElectedMunis;
